import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
@Component({
  selector: 'app-feedback-comment-modal',
  templateUrl: './feedback-comment-modal.component.html',
  styleUrls: ['./feedback-comment-modal.component.css']
})
export class FeedbackCommentModalComponent implements OnInit {

  @Input() select_commentData: any;
  @Input() get_chatData: any;
  @Input() chat_type: any;
    safeHtmlSpeech: SafeHtml;
  safeHtmlAreas: SafeHtml;
  safeHtmlStrengths: SafeHtml;
  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit() {
  }

   ngOnChanges(){
       if (this.select_commentData.ElsaAnalysis) {

        this.safeHtmlSpeech = this.sanitizer.bypassSecurityTrustHtml(this.select_commentData.ElsaAnalysis.speech);
        this.safeHtmlAreas = this.addSeprater(this.select_commentData.ElsaAnalysis.areas_of_improvement);
        this.safeHtmlStrengths = this.addSeprater(this.select_commentData.ElsaAnalysis.strengths);
      }
  }

  closeModel() {
    
  }

       addSeprater(input){
      // Split, trim, and filter out empty strings
      const segments = input.split(';').map(s => s.trim()).filter(s => s.length > 0);

      // Add <p> tags with style only on items after the first
      const wrapped = segments.map((s, i) => {
          if (i === 0) {
              return `<p>${i + 1}. ${s}</p>`;
          } else {
              return `<p style="padding-top:0px">${i + 1}. ${s}</p>`;
          }
      }).join('\n');
      const finalData = this.sanitizer.bypassSecurityTrustHtml(wrapped);
      return finalData

  }


}



// WEBPACK FOOTER //
// ./src/app/application/core-module/scora-modal-module/feedback-comment-modal/feedback-comment-modal.component.ts